<ng-template #blockItem let-block>
  <div class="flex flex-row items-center">
    @if (block.image?.filename) {
      <img class="mr-2.5 min-w-[75px]" [alt]="block.image" width="75px" [src]="get_src(block?.image,false, null, 75 )" loading="lazy" />
    }
    <div>
      <p class="my-0 mt- text-e-dark-green"><b>{{ block.title }}</b></p>
      <p class="my-0 text-e-dark-green">{{ block.subtitle }}</p>
    </div>
  </div>
</ng-template>

<ng-template #cardTitleBlock let-titleClass="titleClass">
  @if (card?.title) {
    @if (isTitleRichtext) {
      <div [ngClass]="titleClass" [innerHTML]="cardTitle"></div>
    } @else {
      <h3 [ngClass]="titleClass">{{ cardTitle }}</h3>
    }
  }
</ng-template>

<ng-template #cardTitleBlockSimple>
  @if (card?.title) {
    <div [innerHTML]="cardTitle"></div>
  }
</ng-template>

<ng-template #cardBodyBlock let-bodyClass="bodyClass">
  <div [ngClass]="bodyClass" [innerHTML]="cardbody"></div>
</ng-template>

<ng-template #cardImageBlock>
  @if (card.main_image?.filename?.startsWith('https')) {
    <app-cms-image imageClass="max-h-[600px] {{card.main_imagecontain ? 'm-auto' : 'object-cover w-full md:h-full rounded-[0.625rem]'}}"  [height]="600" [image]="card.main_image" [contain]="card.main_imagecontain" [loadEager]="false" ></app-cms-image>
  }
  @if (!!video_url) {
    <div class="w-full">
      <iframe title="video_embed" class=" w-full aspect-[16/9] rounded-[0.625rem]" width="100%" frameborder="0" loading="lazy" [src]="video_url"></iframe>
    </div>
  }
</ng-template>

<ng-template #cardImageBlockOld>
  @if (card.main_image?.filename?.startsWith('https')) {
    <app-cms-image class="h-full" imageClass="w-full h-full {{card?.main_imagecontain ? 'object-contain' : 'object-cover'}} {{card?.jumpy_image ? 'rounded-xl' : 'rounded-l-xl'}}"  [height]="600" [image]="card.main_image" ></app-cms-image>
  }
  @if (!!video_url) {
    <div class="h-full w-full md:absolute m-auto md:w-[1000%]">
      <iframe title="video_embed" class="md:absolute w-full h-full" width="100%" height="100%" frameborder="0" loading="lazy" [src]="video_url"></iframe>
    </div>
  }
</ng-template>

<ng-template #cardBlocks>
  @for (block of card.blocks; track block) {
    @switch (block.component) {
      @case ('CTA') {
        <app-cms-button [button]="block"></app-cms-button>
      }
      @default {
        <ng-container *ngTemplateOutlet="blockItem; context: { $implicit: block }"></ng-container>
      }
    }
  }
</ng-template>

@if(card && !card.hidden){
  @if(card.new_design){
    <div class="card-section relative flex flex-col md:flex-row justify-between w-full max-w-[90rem] mx-auto gap-[2.4rem] md:gap-0" [ngClass]="card?.text_color ? 'text-' + card.text_color : ''">
      <div class="flex flex-col flex-grow justify-center md:w-1/2 order-2 md:px-[2rem] lg:px-[3rem] xl:px-[4rem] gap-[1rem]">
        <ng-container *ngTemplateOutlet="cardTitleBlockSimple"></ng-container>
        <ng-container *ngTemplateOutlet="cardBodyBlock; context: { bodyClass: 'flex flex-col' }"></ng-container>
        <ng-container *ngTemplateOutlet="cardBlocks"></ng-container>
      </div>
      <div class="relative md:w-1/2 order-1">
        <div class="flex rounded-[0.625rem] overflow-hidden h-full" [ngClass]="card.main_imagecontain ? 'bg-' + card.image_bgcolor : ''">
          <ng-container *ngTemplateOutlet="cardImageBlock"></ng-container>
        </div>
      </div>
    </div>
  }@else{
    <div class="card flex  justify-center content-normal  md:max-w-full mx-auto rounded-lg md:rounded-l-lg overflow-hidden"
      [ngClass]="[(card.flip_layout? 'flex-col-reverse md:flex-row-reverse': 'flex-col md:flex-row'), (removeMargin? '': 'mt-7')]">
    
        @if(card.main_image?.filename?.startsWith('https') || !!video_url){
          <div class="relative flex items-center justify-center overflow-hidden h-[280px] md:h-auto md:min-h-[300px]"
          [ngClass]="[
            card.main_imagecontain ? 'p-6 md:p-[35px]' : '', 
            card.layout === 'fiftyfifty' ? 'md:w-1/2' : 'flex-grow md:w-1/3', 
            card.jumpy_image ? 'relative z-1 md:my-10' : 'z-0', 
            !!video_url ? 'rounded-t-lg md:rounded-3xl' : '',
            'bg-' + card.image_bgcolor
          ]" 
            >
            <ng-container *ngTemplateOutlet="cardImageBlockOld"></ng-container>
          </div>
        }
        <!-- regular card -->
        @if(!card.jumpy_image){
          <div class="text-left p-6 md:p-[70px]" [ngClass]="[get_classes(card), (!!card.main_image?.filename ? (card.layout === 'fiftyfifty' ? 'md:w-1/2' : 'md:w-2/3') : 'w-full'), card?.text_color ? 'text-' + card.text_color : 'text-e-reg-green']">
            <ng-container *ngTemplateOutlet="cardTitleBlock; context: { titleClass: 'font-serif' }"></ng-container>
            <ng-container *ngTemplateOutlet="cardBodyBlock; context: { bodyClass: 'flex flex-col' }"></ng-container>
            <ng-container *ngTemplateOutlet="cardBlocks"></ng-container>
          </div>
          }@else{
          <!-- card with jumpy image -->
          <div
            class="flex flex-col justify-center text-left p-6 mb-6 md:py-[70px]  rounded-lg"
        [ngClass]="[
          get_classes(card), 
          (card.main_image?.filename || card.video?.cached_url ? (card.layout === 'fiftyfifty' ? 'md:w-1/2 flex-1' : 'md:w-2/3') : 'w-full'),
          card?.text_color ? card.text_color : 'text-e-reg-green',
          card.flip_layout ? 'md:pr-[170px] md:pl-[70px] md:mr-[-100px]': 'md:pl-[170px] md:pr-[70px] md:ml-[-100px]'
        ]">
            <ng-container *ngTemplateOutlet="cardTitleBlock; context: { titleClass: 'font-serif text-e-dark-green' }"></ng-container>
            <ng-container *ngTemplateOutlet="cardBodyBlock; context: { bodyClass: 'flex flex-col items-center' }"></ng-container>
            <ng-container *ngTemplateOutlet="cardBlocks"></ng-container>
          </div>
        }
    </div>
    
      <!-- <div class="text-left p-6 md:p-[70px]" [ngClass]="[get_classes(card), (!!card.main_image?.filename ? (card.layout === 'fiftyfifty' ? 'md:w-1/2' : 'md:w-1/3') : 'w-full'), card?.text_color ? card.text_color : 'text-e-reg-green']"> -->
      
      <!-- <div class="w-full" [ngClass]="['p-6 md:p-[35px]' : card?.main_imagecontain]" [style.backgroundColor]="card?.image_bgcolor" *ngIf="!!card.main_image?.filename"></div> -->
  }
}